import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TimesheetAccessService } from '../components/timesheet-mangement/timesheet-access.service';

/**
 * Blocks `/dashboard/timesheet/timesheet-approval` when the feature flag is off
 * or the user lacks Timesheet Approval permission (submodule 48 / manage).
 */
export const timesheetApprovalGuard: CanActivateFn = () => {
  const router = inject(Router);
  const timesheetAccess = inject(TimesheetAccessService);
  timesheetAccess.refresh();
  if (timesheetAccess.canOpenTimesheetApproval()) {
    return true;
  }
  const fallback = timesheetAccess.firstAccessibleChildPath('timesheet-approval');
  if (fallback) {
    return router.createUrlTree(['/dashboard', 'timesheet', fallback]);
  }
  return router.createUrlTree(['/dashboard', 'home']);
};
